import { ApplicationConfig } from '@angular/core';
import { MenuService } from 'app';
import { createAppConfig } from 'credo';
import { Logo } from 'shared';
import { routes } from './app.routes';
import { logo } from './assets/icons/logo';
import { environment } from './environments/environment';
import { WolfpackassetsMenuService } from './services/menu.service';

// "wolfpackassets" (wolfpack-assets.com) is config domain 7 and shares the
// fac3less backend tenant (userDomainId 0) — a domain-0 user can log in here and
// vice versa, exactly like distribution.
//
// It reuses the fac3less translations and layers a "wolfpackassets" scope on top
// to override only the branded keys (app.name, login.footer). Effective scope
// after createAppConfig: credo,fac3less,wolfpackassets — later wins.
//
// The theme is the Wolfpack dark palette, byte-identical to distribution and
// fac3less; only the logo differs (the wolf-head mark from the marketing site).
export const appConfig: ApplicationConfig = createAppConfig({
  routes,
  providers: [
    { provide: MenuService, useClass: WolfpackassetsMenuService },
  ],
  translationScope: 'fac3less,wolfpackassets',
  // Cookie banner + preference center (Tracking Engine V2, docs/tracking/EVENT_CONTRACT_V2.md).
  // pageId: tracking page of the app outside its checkout; policyKey: document the banner links to.
  consent: { enabled: true, pageId: 'wpa-app', policyKey: 'privacy' },
  environment,
  theme: {
    mode: 'dark',
    colors: {
      primary:   "#00E5FF",
      secondary: "#050505",
      success:   "#00FF9F",
      info:      "#39f",
      warning:   "#f9b115",
      danger:    "#e55353",
      light:     "#ffffff",
      dark:      "#1B1B1B"
    }
  },
  logo: {
      type: 'icon',
      value: logo,
      name: 'wolfpack-assets-logo',
      cssClass: 'logo'
  } as Logo
});
